module.exports = __webpack_public_path__ + "img/DNADamage-SCC_GSE144240.06c85ee9.png";